import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  save(event) {
    // Turbo restores focus to the replaced field by id, which reopens the picker on iOS
    event.target.blur()
    this.element.requestSubmit()
  }
}
